import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import config from 'shared/config/config';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  link: {
    padding: '0.5rem 0',
    width: isMobile ? '4rem' : '100%',
    cursor: 'pointer',
    color: config.pwa_navbar_font_color,
    '&:hover': {
      background: isMobile ? 'none' : config.pwa_navbar_hover_bg_color,
      color: isMobile? 'none': config.pwa_navbar_hover_font_color + ' !important'
    }
  },
  icon: {
    fontSize: '2rem',
  }
});

class NavItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {

  }

  componentDidUpdate() {

  }

  render() {
    const { classes, download, filename, href } = this.props;

    let linkStyle = this.props.iconStyle || {};
    let labelStyle = this.props.labelStyle || {};
    let contentStyle = this.props.contentStyle || {};

    if (isMobile) {
      linkStyle = this.props.iconStyle;
      labelStyle = { display: 'block', fontSize: '0.8rem' };
    } else {
      linkStyle = { ...linkStyle, padding: '10px 20px', margin: '0 -20px' };
      contentStyle = { ...contentStyle, float: 'left' };
      labelStyle = { ...labelStyle, float: 'left' };
    }

    //if (config.mlb) {
    //  labelStyle.fontFamily = '"SF Pro Text Medium", sans-serif';
    //  labelStyle.fontSize = '1rem';
    //}

    let style = {};
    if (this.props.iconStyle) {
      style = { ...this.props.iconStyle };
    }

    if (this.props.disabled) {
      style.opacity = 0.3;
      style.pointerEvents = 'none';
    }

    let target = null;
    if (this.props.target) {
      target = this.props.target;
    } else {
      if (href) {
        target = '_blank';
      }
      if (download) {
        target = '_self';
      }
    }

    var iconProps;
    //if (config.mlb) {
    //  iconProps = {
    //    style: mlbTheme.icon
    //  }
    //} else {
    iconProps = {
      className: classes.icon,
      style: contentStyle
    }
    //}

    return (
      <a className={classes.link}
        href={href}
        target={target}
        download={download}
        filename={filename}
        style={style}
        onClick={this.props.onClick}>
        {React.Children.map(this.props.children, child => {
          return React.cloneElement(child, iconProps);
        })} &nbsp;
        <span style={labelStyle}>{this.props.label}</span>
      </a>
    );

    //const link = inner => {
    //  if (this.props.download) {
    //    return (
    //      <a href={this.props.href} className={classes.link} style={linkStyle} download>
    //        {inner}
    //      </a>
    //    );
    //  } else {
    //    return (
    //      <a href="#" className={classes.link} style={linkStyle} onClick={this.props.onClick}>
    //        {inner}
    //      </a>
    //    );
    //  }
    //}

    //return link(
    //  <div>
    //    {React.Children.map(this.props.children, child => {
    //      return React.cloneElement(child, {
    //        className: classes.icon,
    //        style: contentStyle
    //      });
    //    })}
    //    <span style={labelStyle}>{this.props.label}</span>
    //  </div>
    //)
  }
}

const mapStateToProps = state => ({
});

const NavItemComponent = withStyles(styles, { withTheme: true })(NavItem);

export default connect(mapStateToProps, {})(NavItemComponent);

